import BaseModel from '../../BaseModel';

export default class NotificationTemplateSettings extends BaseModel {
  static entity = 'notificationTemplatesSettings';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      notificationType: this.string(''),
      type: this.string(''),
      enabled: this.boolean(''),
    };
  }

  static apiConfig = {
    actions: {
      async fetchNotificationTemplatesSettings() {
        return this.get('companies/notification-settings');
      },
      async setNotificationTemplateSettings(payload) {
        return this.post('companies/notification-settings', payload);
      },
    },
  }
}
